<template>
  <div class="confirmed-page d-flex flex-column justify-content-between">
    <div class="mb-5">
      <h2 class="mb-5">{{ $t('account.confirmed_title') }}</h2>
      <h5>{{$t('account.confirmed_message')}}</h5>
    </div>
    <div class="d-flex justify--center mt-3">
      <router-link :to="{name: 'login'}">{{$t('auth.go_back')}}</router-link>
    </div>
  </div>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'

export default {
  name: 'consent',
  components: {
    HollowDotsSpinner
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
  .confirmed-page {
    min-height: 30vh;
    @include media-breakpoint-down(md) {
      width: 100%;
      padding-right: 2rem;
      padding-left: 2rem;
      .down-container {
        .link {
          margin-top: 2rem;
        }
      }
    }

    h2 {
      text-align: center;
      margin-bottom: 1rem;
      color: $evollu-gray-dark;
      font-size: 2rem;
      text-transform: none;
    }
    h5 {
      text-align: center;
      color: $evollu-gray-dark;
    }
    // width: 21.375rem;

    .down-container {
      margin-top: 3.125rem;
    }

    .error {
      text-align: center;
      margin-bottom: 1rem;
      color:red;
      word-wrap:break-word;
    }
  }

  .loading {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 40%;
    left: 50%;
  }
</style>
